


























import { Component, Vue } from "vue-property-decorator";
import ProfilesAssociationTable from "@/components/Agents/ProfilesAssociationTable.vue";
import { AdcontrolProfile } from "@/models";
import ProfilesAssociationByProduct, {
  ProfilesAssociationTableMatchType,
} from "@/components/Agents/ProfilesAssociationByProduct.vue";
import { Getter } from "vuex-class";
import SelectOption from "@/interfaces/SelectOption";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import { User } from "@/models";
import { FEATURE_AGENTS_MATCH_BY_PRODUCT } from "@/constants";

@Component({
  components: {
    ProfilesAssociationTable,
    ProfilesAssociationByProduct,
    VMultiSwitcher,
  },
})
export default class ProfilesAssociation extends Vue {
  @Getter("profile") readonly adcontrolProfile!: AdcontrolProfile;
  @Getter("user") readonly user!: User;

  get slug() {
    return this.adcontrolProfile.slug.toUpperCase();
  }

  private selectedMatchOption: ProfilesAssociationTableMatchType = "companies";
  private matchOptions: Array<SelectOption> = [
    { id: "companies", text: "Aziende" },
    { id: "products", text: "Prodotti" },
  ];

  get hasProductsMatchFeature(): boolean {
    return (
      this.user.profile?.hasFeature(FEATURE_AGENTS_MATCH_BY_PRODUCT) ?? false
    );
  }

  get pageTitle(): string {
    const fixedString = `AD ANAGRAFICA ${this.slug}`;

    if (this.hasProductsMatchFeature) {
      const entityNameFromSelectedMatch =
        this.selectedMatchOption === "companies"
          ? "AZIENDE NUOVE NON ASSOCIATE"
          : "PRODOTTI NUOVI NON ASSOCIATI";
      return `${entityNameFromSelectedMatch} ${fixedString}`;
    } else {
      return `BRAND NUOVI NON ASSOCIATI ${fixedString}`;
    }
  }
}
